// removed by extract-text-webpack-plugin
module.exports = {"page-sub-title":"page-sub-title--xnjXZh","icon":"icon--3bPIy6"};